import { Transition, Variants } from 'motion/react';

export const slideTransition: Transition = {
  duration: 0.8,
  ease: [0.74, 0, 0.19, 1.02],
};

export const fadeTransition: Transition = {
  delay: 0.15,
  duration: 0.3,
  ease: 'easeIn',
};

export const fadeInUp: Variants = {
  hidden: {
    opacity: 0,
    y: 50,
    transition: {
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.22, 1, 0.36, 1],
      type: 'spring',
      stiffness: 50,
      damping: 14,
    },
  },
};

export const fadeInUpSlow: Variants = {
  hidden: {
    opacity: 0,
    y: 50,
    transition: {
      duration: 1,
      ease: [0.4, 0, 0.2, 1],
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: [0.4, 0, 0.2, 1],
      type: 'spring',
      stiffness: 50,
      damping: 14,
    },
  },
};

export const fadeIn: Variants = {
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  },
};

export const fadeInUpAnimation: Variants = {
  hidden: {
    opacity: 0,
    y: 50,
    transition: {
      duration: 0.2,
      ease: [0.22, 1, 0.36, 1],
    },
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 50,
      damping: 14,
    },
  },
};
